import { Decimal } from 'decimal.js';

import { StakeNotDividablePreCheckBaseError } from './stake-not-dividable-pre-check-base-error';

export class StakeNotDividablePreCheckError extends StakeNotDividablePreCheckBaseError {
    constructor(exampleStakes: Decimal[], divident: Decimal) {
        super(exampleStakes, divident);
    }
}
